export default {
  state: {
    tint: null,
  },
  actions: {
    updateTint({ commit }, data) {
      commit('setTint', data);
    }
  },
  mutations: {
    setTint(state, data) {
      state.tint = data;
    },
  },
  getters: {
    getTint: state => () => {
      return state.tint;
    }
  },
};
